import type { IDirective } from "angular";
import { module } from "angular";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputEmailDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        ngModel: "=",
    };

    public template: string;

    public link = InputDirectiveFunctions.link; // eslint-disable-line @typescript-eslint/unbound-method

    public compile = InputDirectiveFunctions.compile(this.link);

    // ng-pattern removed since input[type=email] is validated (very loosely) by angular itself
    // ng-pattern-message customizes the message for angular's validation
    constructor() {
        this.template = `<input type="email" aa-field-group="ngModel" aa-label="{{irLabel | translate}}"
            ng-pattern-msg="{{'Validation.IsNotValidEmail' | translate : {propertyName: '{0}'} }}">`;
    }
}

module("mmGui").directive("irInputEmail", () => new InputEmailDirective());
